import { render } from "./UiWave.vue?vue&type=template&id=860f8610&ts=true"
import script from "./UiWave.vue?vue&type=script&lang=ts"
export * from "./UiWave.vue?vue&type=script&lang=ts"

import exportComponent from "/home/ni/IdeaProjects/pioneer/pioneer-lk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__